import client from "../../external/open-api";
import { components } from "../../external/schema/order-link-api-schema";
import { ApplicationError } from "../../models/errors/application-error";
import { ApplicationVAT } from "../../models/finance/application-vat";
import BaseService from "../base-service";
import { IVatInterface } from "./vat-service-interface";

export default class VatService extends BaseService implements IVatInterface {

    async getVatList(): Promise<ApplicationVAT[]> {
        const { data, error } = await this.withRetry(() => client.GET(
            "/v{version}/api/finance/vat",
            {
                params: {
                    path: { version: "1" },
                },
            }
        ));
        if (!data?.data || !data?.success || error) {
            throw new ApplicationError("Failed to fetch vat");
        }

        return data.data.map(x => this.mapToVat(x));
    }

    private mapToVat(vat: components["schemas"]["VatDTO"]): ApplicationVAT {
        return {
            id: vat.id ?? 0,
            description: vat.description ?? "",
            rate: vat.rate ?? 0
        }
    }
}